import { ValidatorFn, Validators } from '@angular/forms';
import { DownloadType } from '../../../dto/enum/download-type.enum';
import { REEL_URL_REGEXP } from '../../../../../validation/const';
import { Injectable } from '@angular/core';
import { AbstractMediaFormProvider } from './abstract-media-form.provider';

@Injectable({
  providedIn: 'root',
})
export class ReelFormProvider extends AbstractMediaFormProvider {
  public getErrorTip = (): string =>
    $localize`:@@download-form-reel-input-error-tip:Please, enter correct Instagram reels link`;
  public getPlaceholder = (): string =>
    $localize`:@@download-form-reel-input-placeholder:Instagram reels link`;
  public getType = (): DownloadType => DownloadType.REEL;
  public override getValidators = (): ValidatorFn[] => [
    Validators.minLength(1),
    Validators.maxLength(192),
    Validators.pattern(REEL_URL_REGEXP),
  ];
}
